//変数定義
let howToModal = null;
let howToOpen = null;
let howToClose = null;
let rewardModal = null;
let resetButton = null;
let rewardButton = null;

const checkPoints = document.getElementsByClassName("collection-item");
const stampClear = document.getElementsByClassName("stamp-clear");
const stampRally = localStorage.getItem("stamp_rallies");

const loadingScreen = document.getElementById("loading-screen");
/**
 * =======================================================
 */

/**
 * 初期化関数
 * =======================================================
 */

// モーダル
const initModal = () => {
  howToModal = document.getElementById("howto");
  howToOpen = document.getElementById("howto-open");
  howToClose = document.getElementById("howto-close");
  rewardButton = document.getElementById("reward-btn");
  rewardModal = document.getElementById("reward-modal");
  resetButton = document.getElementById("reset-btn");
};

/**
 * =======================================================
 */

/**
 * 処理関数
 * =======================================================
 */

const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

const hideLoading = () => {
  loadingScreen.classList.add("is-hidden");
};

//遊び方のボタン表示・非表示
const switchModal = () => {
  if (howToOpen) {
    howToOpen.addEventListener("click", () => {
      howToModal.classList.remove("howto-is-hidden");
    });
  }
  if (howToClose) {
    howToClose.addEventListener("click", () => {
      howToModal.classList.add("howto-is-hidden");
      // modal is-hiddenのtransition時間の関係で0.3秒後としてます
      setTimeout(() => {
        const howToInner = document.getElementsByClassName("howto__inner")[0];
        howToInner.scrollTop = 0;
      }, 300);
    });
  }
};

const loadStamps = (imgDomList) => {
  let loadStartTime;

  if (imgDomList.length === 0 && loadingScreen) {
    hideLoading();
    return;
  }

  const loadPromiseArr = [];

  imgDomList.forEach((img) => {
    loadPromiseArr.push(
      new Promise((resolve, reject) => {
        let timeout;

        img.onload = () => {
          img.setAttribute("data-get", true);
          if (img.parentElement.classList[0] == 'no-action') {
            img.parentElement.classList.remove('no-action');
          }
          clearTimeout(timeout);
          resolve();
        };
        img.src = img.dataset.image;

        timeout = setTimeout(() => {
          reject("timeout");
        }, 20000);
      })
    );
  });

  loadStartTime = performance.now();
  Promise.all(loadPromiseArr)
    .then(() => {
      if (loadingScreen) {
        hideLoading();
      }
    })
    .catch((err) => {
      if (err && err === "timeout") {
        alert("読み込みがタイムアウトしました。ページを再読み込みしてください");
        return;
      }

      alert("エラー：スタンプ画像の読み込みに失敗しました");
    });
};

const judgeAllButtonChecked = (checkPointsArray, parsedStampRally) => {
  let checked = false;
  let localCheckPoints =
    parsedStampRally.stamp_rallies[gon.stamp_rally_slug].check_points;

  if (!gon.is_multiple_check_point) {
    const loadImgList = checkPointsArray.filter((imgElm) => {
      return typeof localCheckPoints[imgElm.dataset.slug] != "undefined";
    });

    loadStamps(loadImgList);
  } else {
    // gon.is_multiple_check_point = trueのとき
    // 1箇所のチェックポイントで　複数回チェックイン可能設定のとき
    showStampMultipleCheckPoint(localCheckPoints);
  }
  if (gon.clear_point > 0) {
    clearPoint = gon.clear_point;
  } else {
    clearPoint = checkPointsArray.length;
  }
  if (gon.is_multiple_check_point) {
    const stampArrayOn = Array.prototype.slice.call(
      document.getElementsByClassName("collection-item-on")
    );
    let count = 0;
    stampArrayOn.map((el) => {
      if (el.getAttribute("data-get") == "true") count += 1;
    });
    if (count >= clearPoint) checked = true;
  }
  if (clearPoint <= Object.keys(localCheckPoints).length) {
    checked = true;
  }
  return checked;
};

const getDataSlugVariation = (checkPointsArray) => {
  let newDataSlugArray = new Array();
  checkPointsArray.map((el) => {
    dataslug = el.getAttribute("data-slug");
    newDataSlugArray.push(dataslug);
  });
  newDataSlugArray = [...new Set(newDataSlugArray)];
  return newDataSlugArray;
};

const showStampMultipleCheckPoint = (localCheckPoints) => {
  const stampArrayOff = Array.prototype.slice.call(
    document.getElementsByClassName("collection-item-off")
  );
  const stampArrayOn = Array.prototype.slice.call(
    document.getElementsByClassName("collection-item-on")
  );
  const dataSlugArray = getDataSlugVariation(stampArrayOff);
  const localCheckPointsKey = Object.keys(localCheckPoints);

  for (let i = 0; i < dataSlugArray.length; i++) {
    dataSlugArray[i] = {
      slug: dataSlugArray[i],
      obj_off: [],
      obj_on: [],
    };
    // dataSlugArrayに、slug（パラメータ）に応じたスタンプ要素on/offのデータ格納
    stampArrayOff.map((el) => {
      if (el.getAttribute("data-slug") == dataSlugArray[i].slug)
        dataSlugArray[i].obj_off.push(el);
    });
    stampArrayOn.map((el) => {
      if (el.getAttribute("data-slug") == dataSlugArray[i].slug)
        dataSlugArray[i].obj_on.push(el);
    });
    localCheckPointsKey.map((el) => {
      // localstorageにパラメーター（スタンプ）があるカテゴリ
      if (el == dataSlugArray[i].slug) {
        let count = localCheckPoints[el].count;
        for (let j = 0; j < dataSlugArray[i].obj_off.length; j++) {
          // countの数だけonに
          if (j < count) {
            dataSlugArray[i].obj_off[j].classList.add("is-hidden");
            dataSlugArray[i].obj_on[j].setAttribute("data-get", true);
            dataSlugArray[i].obj_on[j].classList.remove("is-hidden");
          }
        }
      }
    });
  }
  hideLoading();
};

//報酬ボタンの表示
const enableRewardButton = () => {
  rewardButton.classList.remove("c-btn__unable");
};

const disableRewardButton = () => {
  rewardButton.classList.add("c-btn__unable");
};

//スタンプ全ゲット時　報酬ボタンの挙動
const showRewardModal = () => {
  rewardButton.addEventListener("click", () => {
    if (rewardModal != null) {
      rewardModal.classList.remove("is-hidden");
    }
  });
};

//スタンプ全リセットボタンの挙動
const resetButtonFunc = () => {
  if (!resetButton) return;
  resetButton.addEventListener("click", () => {
    const result = window.confirm("スタンプをリセットします。よろしいですか？");
    if (result) {
      const parsedStampRally = JSON.parse(stampRally);
      let delete_stamp_rally = parsedStampRally.stamp_rallies;
      delete delete_stamp_rally[gon.stamp_rally_slug];
      localStorage.setItem("stamp_rallies", JSON.stringify(parsedStampRally));
      location.reload();
    }
  });
};

const closeModalBtn = () => {
  if (document.getElementById("reward-modal-btn") != null) {
    const rewardModalBtn = document.getElementById("reward-modal-btn");
    rewardModalBtn.addEventListener("click", () => {
      rewardModal.classList.add("is-hidden");
      // modal is-hiddenのtransition時間の関係で0.3秒後としてます
      setTimeout(() => {
        const rewardInner = document.getElementsByClassName("reward-modal__inner")[0];
        rewardInner.scrollTop = 0;
      }, 300);
    });
  }
};

//獲得したスタンプの表示
const displayCheckedStamp = () => {
  let checkPointsArray = Array.prototype.slice.call(checkPoints);
  const parsedStampRally = JSON.parse(stampRally);

  if (parsedStampRally && parsedStampRally.stamp_rallies[gon.stamp_rally_slug]) {
    checked = judgeAllButtonChecked(checkPointsArray, parsedStampRally);
    if (checked && rewardButton) {
      enableRewardButton();
    }
  } else {
    hideLoading();
  }
};

const attachTriggerIfInitAll = () => {
  switchModal();
  displayCheckedStamp();
};

const lotteryCompleteCheck = () => {
  if (gon.exchanged_lottery && rewardButton) {
    disableRewardButton();
  }
};

window.addEventListener("load", () => {
  initModal();
  setFillHeight();
  attachTriggerIfInitAll();
  resetButtonFunc();
  showRewardModal();
  closeModalBtn();
  lotteryCompleteCheck();
});

window.addEventListener("resize", setFillHeight);
